/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ScheduleExecutionParameterServiceAccountBase extends models.ScheduleExecutionParameterBase {
    constructor() {
        super();
        this.setDiscriminator("ScheduleExecutionParameterServiceAccountBase");
    }

    getFixupPrototypeFunction() { return ScheduleExecutionParameterServiceAccountBase.fixupPrototype; }

    static newInstance(model: Partial<ScheduleExecutionParameterServiceAccountBase>): ScheduleExecutionParameterServiceAccountBase {
        let obj = Object.assign(new ScheduleExecutionParameterServiceAccountBase(), model);
        ScheduleExecutionParameterServiceAccountBase.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ScheduleExecutionParameterServiceAccountBase>): ScheduleExecutionParameterServiceAccountBase {
        if (!model) return null;
        return ScheduleExecutionParameterServiceAccountBase.newInstance(<ScheduleExecutionParameterServiceAccountBase> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ScheduleExecutionParameterServiceAccountBase) {
        if (!obj) return;

        models.ScheduleExecutionParameterServiceAccountBase.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ScheduleExecutionParameterServiceAccountBase): boolean {
        if (models.ScheduleExecutionParameterBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ScheduleExecutionParameterServiceAccountBase.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Service account ID, can be obtained from the List Service Accounts API.
     */
    service_account_id: string;

}
